import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import RepaymentInitiatedListPageUI from './RepaymentInitiatedListPageUI.js'

class RepaymentInitiatedListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      repaymentList: null,

      filteredTransactionList: null,
      searchFilter: '',
      copyToClipboardText: null,
    }
  }

  render() {
    return (
      <RepaymentInitiatedListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        repaymentList={this.state.repaymentList}
        filteredTransactionList={this.state.filteredTransactionList}
        onRefreshClick={this.onRefreshClick}
        //
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        copyToClipboardText={this.state.copyToClipboardText}
        onCopyToClipboard={this.onCopyToClipboard}
      />
    )
  }

  componentDidMount() {
    console.log('here');
    let context = this.props.context
    this.getInitiatedRepayments(context)
  }

  getInitiatedRepayments(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/repayments/initiated`,
      cacheKey: CacheKeys.RepaymentsInitiated(),
      callback: this.getInitiatedRepaymentsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getInitiatedRepaymentsCallback = (response) => {
    this.setState({repaymentList: response.repaymentList})
    //let filtersStr = sessionStorage.getItem(CacheKeys.PendingTxnsFilter())
    //let filters = filtersStr ? JSON.parse(filtersStr) : {}

    //this.applyFilters(response.repaymentList, filters.searchFilter ? filters.searchFilter : '', response.errorList)
  }

  onCopyToClipboard = (text, result) => {
    this.setState({copyToClipboardText: text})
    setTimeout(() => {
      this.setState({copyToClipboardText: null})
    }, 3000)
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.repaymentList, searchFilter)
  }

  applyFilters(repaymentList, searchFilter, errorList) {
    let filteredList = repaymentList
    if (searchFilter)
      filteredList = filteredList.filter(txn => txn.accountName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()))

    this.setState({
      repaymentList: repaymentList,
      filteredTransactionList: filteredList,
      searchFilter: searchFilter,
      errorList: errorList
    })

    let filters = { searchFilter: searchFilter }
    sessionStorage.setItem(CacheKeys.PendingTxnsFilter(), JSON.stringify(filters))
  }

  onRefreshClick = (noBusy) => {
    CacheManager.removeObject(CacheKeys.RepaymentsInitiated())
    if (noBusy === 'noBusy') {
      this.getInitiatedRepayments(this.props.context)
    }
    else {
      this.setState({repaymentList: null, errorList: null},
        this.getInitiatedRepayments(this.props.context)
      )
    }
  }
}

export default RepaymentInitiatedListPageSF
